import { z } from 'zod/v4';

export const createApiKeySchema = z.object({
  keyType: z.string().min(1, 'Тип ключа обязателен'),
  name: z.string().min(1, 'Название обязательно'),
  value: z.record(z.string(), z.any()),
  isActive: z.boolean().optional(),
});

export const updateApiKeySchema = z.object({
  keyType: z.string().min(1).optional(),
  name: z.string().min(1).optional(),
  value: z.record(z.string(), z.any()).optional(),
  isActive: z.boolean().optional(),
});

export type CreateApiKeyInput = z.infer<typeof createApiKeySchema>;
export type UpdateApiKeyInput = z.infer<typeof updateApiKeySchema>;
